import { useState } from "react";
import { Reveal } from "../components/Reveal";
import { api, formatApiErrorDetail } from "../lib/api";

const FAQS = [
  { q: "Quels sont les délais de livraison ?", a: "Commande préparée sous 24-48h ouvrées, puis 2-4 jours pour la France, 3-7 pour l'Europe et 5-12 jours pour l'international." },
  { q: "Puis-je échanger une taille ?", a: "Oui : renvoyez la pièce neuve avec ses étiquettes sous 14 jours et nous vous expédions la taille souhaitée selon disponibilité." },
  { q: "Comment choisir ma taille ?", a: "Nos coupes sont oversize : prenez votre taille habituelle pour une fit ajustée, une taille au-dessus pour un tombé ample." },
  { q: "Le paiement est-il sécurisé ?", a: "Oui : paiement traité par Stripe Checkout. Moha66 ne voit jamais vos données bancaires et ne les stocke jamais." },
];

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setSending(true);
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.message));
    } finally {
      setSending(false);
    }
  };

  const inputCls = "w-full bg-panel border border-line focus:border-white outline-none px-4 py-3 text-sm text-white placeholder:text-neutral-600 transition-colors";

  return (
    <main className="pt-28 sm:pt-36 pb-24 px-4 sm:px-8 lg:px-16 min-h-screen" data-testid="contact-page">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
        <div>
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-neutral-500">Parlons-en</p>
            <h1 className="mt-3 font-display font-extrabold uppercase tracking-tighter text-4xl sm:text-6xl text-white">
              Con<span className="text-outline-strong">tact</span>
            </h1>
            <p className="mt-6 text-sm sm:text-base text-neutral-400 leading-relaxed max-w-md">
              Une question sur une pièce, une commande, un retour ? Écrivez-nous :
              l'équipe Moha66 vous répond au plus vite.
            </p>
          </Reveal>

          <div className="mt-12 space-y-3" data-testid="contact-faq">
            {FAQS.map((f, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <details className="group border border-line bg-coal" data-testid={`contact-faq-item-${i}`}>
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="font-grotesk font-semibold uppercase tracking-wider text-sm text-white">{f.q}</span>
                    <span className="text-neutral-500 group-open:rotate-45 transition-transform duration-300">+</span>
                  </summary>
                  <p className="px-5 pb-5 text-sm text-neutral-400 leading-relaxed">{f.a}</p>
                </details>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="border border-line bg-coal p-6 sm:p-10">
            {sent ? (
              <div className="text-center py-16" data-testid="contact-success">
                <p className="font-display font-extrabold uppercase text-3xl text-white">Message envoyé</p>
                <p className="mt-4 text-sm text-neutral-400">Merci ! Nous revenons vers vous très vite.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
                <h2 className="font-display font-bold uppercase tracking-wider text-lg text-white">Écrivez-nous</h2>
                <div>
                  <label htmlFor="ct-name" className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Nom *</label>
                  <input id="ct-name" data-testid="contact-name-input" required value={form.name} onChange={set("name")} className={`mt-2 ${inputCls}`} />
                </div>
                <div>
                  <label htmlFor="ct-email" className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Email *</label>
                  <input id="ct-email" data-testid="contact-email-input" type="email" required value={form.email} onChange={set("email")} className={`mt-2 ${inputCls}`} />
                </div>
                <div>
                  <label htmlFor="ct-subject" className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Sujet</label>
                  <input id="ct-subject" data-testid="contact-subject-input" value={form.subject} onChange={set("subject")} className={`mt-2 ${inputCls}`} placeholder="Commande, taille, retour…" />
                </div>
                <div>
                  <label htmlFor="ct-message" className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Message *</label>
                  <textarea id="ct-message" data-testid="contact-message-input" required rows="5" value={form.message} onChange={set("message")} className={`mt-2 ${inputCls}`} />
                </div>
                <button type="submit" data-testid="contact-submit-button" disabled={sending} className="w-full bg-white text-ink font-mono text-xs uppercase tracking-[0.25em] py-4 hover:bg-gold disabled:opacity-50 transition-colors duration-300">
                  {sending ? "Envoi…" : "Envoyer le message"}
                </button>
                {error && <p className="font-mono text-xs text-red-400" data-testid="contact-error">{error}</p>}
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </main>
  );
};

export default Contact;
